jQuery(function() {
  if ($("#store_locator").length) {
    const wtbButtons = [
      ...document.querySelectorAll(".c-where-to-buy__button")
    ];
    let stores;
    let storesList;
    let markers;
    let isMobile = window.innerWidth < 768 ? true : false;
    const showStoresListTranslation = bloginfo.stores_list_string;
    const exitBtnMobileTranslation = bloginfo.exit_btn_string;
    const calcMapHeight = () => {
      let storeLocatorContainer = document.querySelector("#store_locator");
      let storeMap = document.querySelector("#store_locator_map");
      let windowHeight = window.innerHeight;
      let storesList = document.querySelector("#store_locator_result_list_box");
      let headerHeight = document.querySelector("#store_locator_search_box")
        .offsetHeight;
      let toggleBarHeight = 0;

      if (isMobile) {
        let toggleBarHeight = document.querySelector(".toggle-bar")
          .offsetHeight;
      }

      let mapHeight;

      if (storeLocatorContainer.classList.contains("stores-collapsed")) {
        mapHeight = windowHeight - (toggleBarHeight + headerHeight);
        storeMap.style = "height:" + mapHeight + "px !important";
      } else {
        mapHeight = windowHeight - (storesList.offsetHeight + headerHeight);
        storeMap.style = "height:" + mapHeight + "px !important";
      }
    };

    const openStoresList = (showAllStores = true) => {
      const storeList = document.querySelector(
        "#store_locator_result_list_box"
      );

      if (showAllStores) {
        storeList.classList.add("store_locator_result_list_box_open");
      }
    };

    const collapseStoresList = () => {
      let storesList = document.querySelector("#store_locator_result_list_box");
      let storeLocatorContainer = document.querySelector("#store_locator");
      let storesListContainer = document.querySelector(
        "#store_locator_result_list"
      );

      storesList.style.top = "calc(100% - 52px)";
      if (!storeLocatorContainer.classList.contains("stores-collapsed")) {
        storeLocatorContainer.classList.add("stores-collapsed");
        storesListContainer.style.height = "auto";
      }

      calcMapHeight();
    };

    const openSingleStore = () => {
      [...document.querySelectorAll(".store_locator_result_list_item")].map(
        store => {
          setTimeout(() => {
            store.classList.contains("store_locator_result_list_item_hover")
              ? store.classList.add("store_locator_result_list_item_active")
              : store.classList.remove("store_locator_result_list_item_active");
          }, 500);
        }
      );

      let showAllStores = false;

      openStoresList(showAllStores);
    };

    const scrollToStore = element => {
      const parent = document.querySelector(".store_locator_result_list_box");

      if (parent) {
        const parentRect = parent.getBoundingClientRect();
        const elementRect = element.getBoundingClientRect();
        const offset = elementRect.top - parentRect.top + parent.scrollTop;

        parent.scrollTo({
          top: offset,
          behavior: "smooth"
        });
      }
    };

    const addToggle = () => {
      const storesList = document.querySelectorAll(
        ".store_locator_result_list_item"
      );

      storesList.forEach(store => {
        store.addEventListener("click", function() {
          storesList.forEach(item => {
            if (item !== store) {
              item.classList.remove("store_locator_result_list_item_active");
            }
          });

          const storeWrapper = document.querySelector(
            ".store_locator_result_list_box_open"
          );

          if (storeWrapper) {
            storeWrapper.classList.remove("store_locator_result_list_box_open");
          }

          store.classList.toggle("store_locator_result_list_item_active");
          calcMapHeight();
        });
      });
    };

    const markersUpdate = () => {
      const checkActiveStore = () => {
        stores.map(store => {
          store.classList.forEach(storeClass => {
            storeClass == "store_locator_result_list_item_hover"
              ? scrollToStore(store)
              : null;
          });
        });
      };

      markers = [
        ...document.querySelectorAll(
          '#store_locator_map div img[src="https://maps.gstatic.com/mapfiles/transparent.png"]'
        )
      ];

      markers.map(marker => {
        marker.addEventListener("click", () => {
          const storesList = document.querySelectorAll(
            ".store_locator_result_list_item"
          );

          storesList.forEach(store => {
            store.classList.remove("store_locator_result_list_item_active");
          });
          setTimeout(() => {
            const activeStore = document.querySelector(
              ".store_locator_result_list_item_hover"
            );

            activeStore.classList.add("store_locator_result_list_item_active");
          }, 500);
        });

        if (isMobile) {
          marker.addEventListener("touchend", function() {
            setTimeout(checkActiveStore, 100);
            setTimeout(openSingleStore, 100);
          });
        } else {
          marker.addEventListener("click", function() {
            setTimeout(checkActiveStore, 100);
          });
        }
      });
    };

    const storesUpdate = () => {
      const storesContainer = document.querySelector(
        "#store_locator_result_list"
      );

      stores = [
        ...storesContainer.querySelectorAll(".store_locator_result_list_item")
      ];

      if (storesContainer.childNodes.length > 1) {
        addToggle();
        markersUpdate();
      }

      const storesObserver = new MutationObserver(() => {
        if (storesContainer) {
          stores = [
            ...storesContainer.querySelectorAll(
              ".store_locator_result_list_item"
            )
          ];
          addToggle();
        }
      });

      storesObserver.observe(storesContainer, {
        subtree: true,
        childList: true
      });

      const addToggleIconMobile = () => {
        if (!document.querySelector(".toggle-bar")) {
          let storesList = document.querySelector(
            "#store_locator_result_list_box"
          );
          let openStoresEl = document.createElement("div");

          openStoresEl.classList.add("toggle-bar");
          openStoresEl.innerHTML =
            "<div class='toggle-icon'></div><p>" +
            showStoresListTranslation +
            "</p>";
          storesList.prepend(openStoresEl);
        }
      };

      const addExitBtnMobileText = () => {
        let closeButtonContent = document.querySelector(".modal-header .close");

        if (!closeButtonContent) return;

        let exitBtnTextEl = document.createElement("p");

        exitBtnTextEl.classList.add("button-text");
        exitBtnTextEl.innerHTML = exitBtnMobileTranslation;
        closeButtonContent.append(exitBtnTextEl);
      };

      const handleMobile = () => {
        addToggleIconMobile();

        let openStoresEl = document.querySelector(".toggle-bar");

        collapseStoresList();

        let closeButton = document.querySelector(".modal-header");

        if (closeButton) {
          closeButton.addEventListener("click", collapseStoresList, false);
        }

        !document.querySelector(".modal-header .close .button-text")
          ? addExitBtnMobileText()
          : null;

        openStoresEl.addEventListener("click", openStoresList, false);

        let showMapBtn = document.querySelector(".show-map-button");

        if (showMapBtn) {
          showMapBtn.addEventListener("click", collapseStoresList, false);
        }
      };

      isMobile ? handleMobile() : null;
    };

    const observeLoader = () => {
      const slLoader = document.querySelector("#store_locator_loading");
      const storesLoaderObserver = new MutationObserver(() => {
        isMobile ? collapseStoresList() : null;
        if (slLoader.classList.contains("store_locator_hidden")) {
          setTimeout(markersUpdate, 500);
        }
      });

      storesLoaderObserver.observe(slLoader, {
        subtree: true,
        childList: true,
        attributes: true
      });
    };

    const storeLocatorInit = () => {
      //calcMapHeight();
      storesUpdate();
      observeLoader();
    };

    // wtbButtons.map(wtbButton => {
    //   wtbButton.addEventListener("click", function() {
    storeLocatorInit();
    //   });
    // });
  }
});
